module.exports = __webpack_public_path__ + "64914697633b2252b3e90635c6eba4e1.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/project/img/Animalz.jpg
// module id = 487
// module chunks = 0